import React, { useEffect, useRef, useState } from 'react'
import About from '../components/About/About'
import { Timeline, timelineItemClasses, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent } from '@mui/lab'
import { Button } from '@mui/material'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar/Navbar'
import Newsletter from '../components/Newsletter/Newsletter'
import Pricing from '../components/Pricing/Pricing'
import backgroundVideo from '../media/background_video.mp4';
import FadeInSection from '../utilities/FadeInSection/FadeInSection'

const Home = () => {

    const [activeSection, setActiveSection] = useState(null);
    const sections = useRef<any>([]);

    const handleScroll = () => {
        const pageYOffset = window.scrollY;
        let newActiveSection = null;

        sections.current.forEach((section: { offsetTop: any; offsetHeight: any; id: any; }) => {
            const sectionOffsetTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            if (pageYOffset >= sectionOffsetTop && pageYOffset < sectionOffsetTop + sectionHeight) {
                newActiveSection = section.id;
            }
        });

        setActiveSection(newActiveSection);
    };

    useEffect(() => {
        sections.current = document.querySelectorAll('[data-section]');
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const activeStyle = {
        fontWeight: 'bold',
        fontSize: '16px',
        transition: '500ms'
    };
    const activeStyle2 = {
        fontWeight: 'bold',
        fontSize: '16px',
        color: 'black',
        transition: '500ms'
    };

    return (
        <>
            {/* <div className="App-header"> */}
            <Navbar />
            {/* <div data-section className='video-container' id="home-section"> */}
            <video src={backgroundVideo} id="background-video" autoPlay loop muted />
            {/* </div> */}


            <div className="text-overlay">
                <p>Taking you Further!</p>
                <Button className='hero-button' size='large' variant="outlined">See Pricing</Button>
            </div>

            <main>
                <FadeInSection>
                    <About />
                </FadeInSection>

                <FadeInSection>
                    <Pricing />
                </FadeInSection>

                <FadeInSection>
                    <Newsletter />
                </FadeInSection>

                <Footer />
            </main>
            {/* </div> */}



        </>
    )
}

export default Home